// onStart - triggers immediately
export default async function onStart(callback) {
  callback();
}
